module.exports = __webpack_public_path__ + "img/bixiu07.978fd2df.png";